<button pButton *ngIf="edit" (click)="calcContents()">{{'generate_preview'| translation}}</button>
<div #container [innerHTML]="genHTML(item.html)| safeHtml">
</div>
<!--<div>

  <button pButton *ngIf="edit" (click)="compileTemplate()">Generate Preview</button>
  <div #container></div>
</div>
-->
